export enum MachineAssignmentArea {
  Knitting = 'Knitting',
  RollQc = 'RollQc',
  Batching = 'Batching',
  Dyeing = 'Dyeing',
  Finishing = 'Finishing',
  Rolling = 'Rolling',
}

export interface MachineAssignmentAreaOption {
  label: string;
  value: MachineAssignmentArea;
  costCenterCode: string;
}

export const MACHINE_ASSIGNMENT_AREA_COST_CENTERS: Record<MachineAssignmentArea, string> = {
  [MachineAssignmentArea.Knitting]: '1010102130',
  [MachineAssignmentArea.Batching]: '1010104007',
  [MachineAssignmentArea.Dyeing]: '1010105019',
  [MachineAssignmentArea.Finishing]: '1010115001',
  [MachineAssignmentArea.Rolling]: '1010114011',
  [MachineAssignmentArea.RollQc]: '1010202006',
};
